// extracted by mini-css-extract-plugin
module.exports = {"add_element":"add_element-GYON3","person_element":"person_element-TjiVW"};